import { render, staticRenderFns } from "./ORegisterPassEdit.vue?vue&type=template&id=0fa3e47a&scoped=true&"
import script from "./ORegisterPassEdit.vue?vue&type=script&lang=ts&"
export * from "./ORegisterPassEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa3e47a",
  null
  
)

export default component.exports